import SocketConnection from "itoeste-socket"
import { DEBUG } from "../../env";
let _SOCKET
if(!DEBUG){
	_SOCKET = SocketConnection({
		debug:DEBUG,
		token:"eyJhbGciOiJIUzI1NiJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJJRUEiLCJlbWFpbCI6ImVkdWFyZG9pdG9lc3RlQGdtYWlsLmNvbSIsInBhc3N3b3JkIjoiJDJiJDEwJEM0M2M1dUl4R3BoVzk1RElod0ZJVWUzT1BFVDFjbTdQNzZMTTVuM2daWFNUNS5EaWFTRHNHIiwiY2hhbm5lbCI6IklFQSIsInVwZGF0ZWRBdCI6IjIwMjAtMTEtMzBUMTE6MTQ6MTIuODMxWiIsImNyZWF0ZWRBdCI6IjIwMjAtMTEtMzBUMTE6MTQ6MTIuODMxWiJ9.M8TW0YDXeSNuns-VTKIK0NtauWBQ2UceDrqgJUtiDQ0"
	},()=>{
		
	});
}


export default _SOCKET